import React, { Fragment } from 'react';
import styled from 'styled-components';

import { useTranslation } from 'react-i18next';

import { eAsigSteps } from '../../constants/steps';

import Arrow from '../../assets/Arrow.svg';
import { Text22 } from '../../ui/Text22';
import { Text18 } from '../../ui/Text18';

const Wrapper = styled.div`
  margin-top: 93px;
  justify-content: space-between;

  @media (max-width: 1035px) {
    display: none;
  }
`;

const StepsWrapBorder = styled.div`
  display: inline-flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
`;

const StepWrapper = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  flex: 1;
`;

const StepNumber = styled.h2`
  color: ${({ theme }) => theme.colors.accentBlue};
  margin-right: 24px;
`;

const StepDescription = styled(Text22)`
  color: ${({ theme }) => theme.colors.blackColor};
  max-width: 250px;
`;

const ArrowStep = styled.img`
  padding: 0 25px;
`;

const StepsActiveNumber = styled(Text18)<{ isActive: boolean }>`
  color: ${({ isActive, theme: { colors } }) =>
    isActive ? colors.darkGray : colors.whiteColor};
  font-weight: 700;
  font-size: 14px !important;  
`;

const Pointer = styled.div<{ activeStep: number; index: number }>`
  display: flex;
  flex: none;
  align-items: center;
  background: ${({ activeStep, index, theme: { colors } }) =>
    activeStep === index + 1
      ? colors.accentBlue
      : activeStep > index + 1
      ? colors.mediumBlue
      : colors.whiteColor};
  border-right: 20px solid blue;
  border-left: 20px solid blue;
  border-left-color: ${({ activeStep, index, theme: { colors } }) =>
    activeStep === index + 1
      ? colors.accentBlue
      : activeStep > index + 1
      ? colors.mediumBlue
      : colors.whiteColor};
  border-right-color: ${({ activeStep, index, theme: { colors } }) =>
    activeStep === index + 2
      ? colors.accentBlue
      : activeStep > index + 2
      ? colors.mediumBlue
      : colors.whiteColor};

  &:before {
    border-left-color: ${({ activeStep, index, theme: { colors } }) =>
      activeStep === index + 1
        ? colors.accentBlue
        : activeStep > index + 1
        ? colors.mediumBlue
        : colors.whiteColor};
  }
`;

const InsuranceSteps: React.FC<{ activeStep?: number }> = ({ activeStep }) => {
  const { t } = useTranslation();  

  return (
    <Wrapper>
      <StepsWrapBorder>
        {eAsigSteps.map((step, index) => {
          const description = Object.values(step).toString();
          const stepNumber = Object.keys(step).toString();
          return (
            <Fragment key={index}>
              {!activeStep ? (
                <StepWrapper>
                  <StepNumber>{index + 1}</StepNumber>
                  <StepDescription>{t(description)}</StepDescription>
                </StepWrapper>
              ) : (               
                <Pointer
                  activeStep={activeStep}
                  index={index}
                  className='pointer'
                >
                  <StepsActiveNumber isActive={activeStep <= index}>{`${
                    index + 1
                  }. ${t(description)}`}</StepsActiveNumber>
                </Pointer>
              )}
              {eAsigSteps.length !== Number(stepNumber) && !activeStep && (
                <ArrowStep src={Arrow} />
              )}
            </Fragment>
          );
        })}
      </StepsWrapBorder>
    </Wrapper>
  );
};

export default InsuranceSteps;
